import validatePaymentAmount from './essensys/validatePaymentAmount';

export default {
  essensys: {
    validatePaymentAmount,
  },
} as const;
